import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import getTopicsMenuName from 'hb-react/shared/apps/TopicsIndexV2/utils/getTopicsMenuName';

const useTopicsMenuName = () => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();

  const defaultName = s__('Topics|Topics');

  if (!currentUser) {
    // return custom tab name
    if (currentNetwork?.features?.topics?.config?.menu_name) {
      return currentNetwork.features.topics.config.menu_name;
    }

    return defaultName;
  }

  const menuName = getTopicsMenuName(currentNetwork);

  return menuName || defaultName;
};

export default useTopicsMenuName;
